import { render, staticRenderFns } from "./discover.vue?vue&type=template&id=68f40c4a&scoped=true"
import script from "./discover.vue?vue&type=script&lang=js"
export * from "./discover.vue?vue&type=script&lang=js"
import style0 from "./discover.vue?vue&type=style&index=0&id=68f40c4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f40c4a",
  null
  
)

export default component.exports